export default __webpack_public_path__ + "static/1008-a2c1db8ad6294c62c3908ebc226edeb0.gif";